<template>
  <div>
    <div class="top">
      <img class="picimg" src="@/assets/image/智慧街区数字化服务.png" />
    </div>
    <div style="display: flex; align-items: center" class="prompt">
      <img class="icon" src="@/assets/images/zhuye.png" />
      <span class="color858"
        >&nbsp;&nbsp;你现在的位置&nbsp;&nbsp;/&nbsp;&nbsp;首页&nbsp;&nbsp;/&nbsp;&nbsp;</span
      >
      <span>智慧街区数字化服务</span>
    </div>
    <div class="titleBox">
      <span class="title">SMART BLOCK</span>
      <span class="title1">智慧街区数字化服务</span>
      <span class="line"></span>
    </div>
    <div class="service-main sb-main">
      <p class="sb-tagline">科技赋能 · 智慧升级</p>

      <figure class="sb-hero">
        <div class="sb-hero-img-wrap">
          <img
            class="sb-hero-img"
            src="@/assets/image/驾驶舱1.png"
            alt="智慧街区驾驶舱"
          />
        </div>
        <figcaption class="sb-hero-cap">智慧街区驾驶舱</figcaption>
      </figure>

      <p class="sb-intro">
        通过构建“1+1+3+N”的整体架构，即一个AI智能场景分析平台、一个数字孪生平台、三大应用平台及N个配套系统，全面提升街区管理精度、运营效率与游客体验。
      </p>

      <div class="sb-grid">
        <div class="sb-col sb-col--left">
          <div class="sb-oper-wrap">
            <section class="sb-block sb-block--oper">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                智慧运营平台
              </h3>
              <p class="sb-p">
                以“提升游客体验、促进商户增收”为目标，包含数字人应用、AR互动、街区综合管控APP、游客服务小程序等内容。
              </p>
            </section>
            <div class="sb-oper-images" aria-label="智慧运营平台配图">
              <img
                class="sb-oper-img"
                src="@/assets/image/智慧运营平台.jpg"
                alt="智慧运营平台"
              />
            </div>
          </div>

          <div class="sb-security-wrap">
            <div class="sb-security-images" aria-label="智慧安防平台配图">
              <img
                class="sb-security-img"
                src="@/assets/image/安防.png"
                alt="智慧安防平台"
              />
            </div>
            <section class="sb-block sb-block--security">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                智慧安防平台
              </h3>
              <p class="sb-p">
                整合AI智能场景分析与数字孪生能力，聚焦“事前预警、事中处置、事后溯源”，构建全流程安防管理体系，保障人员、文物与设施安全。
              </p>
            </section>
          </div>

          <div class="sb-mgmt-wrap">
            <section class="sb-block sb-block--mgmt">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                智慧管理平台
              </h3>
              <p class="sb-p">
                围绕“精细化管理、高效化运营”，整合信息发布、招商管理、综合监测、大数据分析等功能，覆盖街区日常管理全场景。
              </p>
            </section>
            <div class="sb-oper-images" aria-label="智慧管理平台配图">
              <img
                class="sb-oper-img"
                src="@/assets/image/管理平台.png"
                alt="智慧管理平台"
              />
            </div>
          </div>

          <div class="sb-ai-wrap">
            <div class="sb-security-images" aria-label="AI 智能场景分析平台配图">
              <img
                class="sb-security-img"
                src="@/assets/image/AI智能分析平台.png"
                alt="AI 智能场景分析平台"
              />
            </div>
            <section class="sb-block sb-block--ai">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                AI 智能场景分析平台
              </h3>
              <p class="sb-p">
                依托物联网感知设备采集的视频、环境、设备等海量数据，通过深度学习与计算机视觉技术，实现多场景智能识别、实时预警与数据研判，为街区管理提供精准支撑。
              </p>
            </section>
          </div>

          <div class="sb-twin-wrap">
            <section class="sb-block sb-block--twin">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                数字孪生平台
              </h3>
              <p class="sb-p">
                以“物理空间数字化、数字空间可视化”为目标，构建街区高精度三维模型，实现物理空间与数字空间的实时映射，为街区管理提供可视化、仿真化、智能化的决策工具。
              </p>
            </section>
            <div class="sb-oper-images" aria-label="数字孪生平台配图">
              <img
                class="sb-oper-img"
                src="@/assets/image/数字孪生平台.png"
                alt="数字孪生平台"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom />
    <Right />
  </div>
</template>

<script>
import Bottom from "./bottom.vue";
import Right from "./right.vue";

export default {
  components: {
    Bottom,
    Right,
  },
};
</script>

<style lang="scss" scoped>
$sb-blue: #5b9bd5;
$sb-yellow: #e6c229;
$sb-line: rgba(50, 115, 202, 0.95);

.service-main.sb-main {
  max-width: 960px;
  margin: 0 auto 80px;
  padding: 0 40px;
  line-height: 1.85;
  font-size: 16px;
  color: #333;
}

.sb-tagline {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: $sb-line;
  margin: 8px 0 28px;
}

.sb-hero {
  margin: 0 0 28px;
}

.sb-hero-img-wrap {
  border-radius: 8px;
  overflow: hidden;
  background: #f0f4f8;
  border: 1px solid #e0e6ef;
}

.sb-hero-img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 420px;
  object-fit: contain;
}

.sb-hero-cap {
  margin: 10px 0 0;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #444;
}

.sb-intro {
  margin: 0 0 32px;
  text-align: justify;
  text-indent: 2em;
}

/* 平台图文分栏：等宽双列 + 行内垂直居中，整行在内容区内水平居中 */
.sb-oper-wrap,
.sb-security-wrap,
.sb-mgmt-wrap,
.sb-ai-wrap,
.sb-twin-wrap {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  justify-items: stretch;
  gap: 24px 32px;
  width: 100%;
  max-width: 920px;
  margin: 0 auto 28px;
  min-width: 0;
}

.sb-block--oper,
.sb-block--security,
.sb-block--mgmt,
.sb-block--ai,
.sb-block--twin {
  min-width: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.sb-oper-images,
.sb-security-images {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
  padding: 4px 0;
}

.sb-oper-img,
.sb-security-img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 280px;
  object-fit: contain;
  object-position: center center;
}

.sb-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 28px 32px;
  align-items: flex-start;
}

.sb-col {
  flex: 1 1 300px;
  min-width: 0;
}

.sb-col--left {
  flex: 1 1 52%;
}

.sb-block {
  margin-bottom: 28px;
  padding: 16px 18px;
  background: rgba(91, 155, 213, 0.08);
  border: 1px solid rgba(91, 155, 213, 0.35);
  border-radius: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.sb-h3 {
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: 700;
  color: $sb-blue;
  margin: 0 0 12px;
}

.sb-h3-mark {
  width: 8px;
  height: 8px;
  background: $sb-yellow;
  margin-right: 8px;
  flex-shrink: 0;
}

.sb-p {
  margin: 0;
  text-align: justify;
}

.sb-news {
  margin: 20px 0 0;
}

.sb-news-img-wrap {
  border-radius: 8px;
  overflow: hidden;
  background: #1a1a1a;
  border: 1px solid #ddd;
}

.sb-news-img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 280px;
  object-fit: contain;
}

.sb-news-cap {
  margin: 10px 0 0;
  font-size: 13px;
  line-height: 1.65;
  color: #555;
}

@media (max-width: 768px) {
  .service-main.sb-main {
    padding: 0 20px;
  }

  .sb-hero-img {
    max-height: 260px;
  }

  .sb-col--left {
    flex: 1 1 100%;
  }

  .sb-oper-wrap,
  .sb-security-wrap,
  .sb-mgmt-wrap,
  .sb-ai-wrap,
  .sb-twin-wrap {
    grid-template-columns: minmax(0, 1fr);
    max-width: none;
    margin-left: 0;
    margin-right: 0;
    gap: 16px;
  }

  .sb-oper-img,
  .sb-security-img {
    max-height: 240px;
  }
}
</style>
